import { Flex, Select, Space } from 'antd';
import { ImpactLocation } from 'lib/documents';
import { selectMultipleProps } from 'lib/utils/antd';
import { useState } from 'react';
import { impactLocationOptions } from '../utils/select-options-injury';
import { ImpactLocationDiagram } from './impact-location-diagram';

/**
 * The input for impact location.
 * This renders a select dropdown and an impact location diagram.
 *
 * This component was split from the parent for performance.
 */
export function ImpactLocationInput(props: {
  name?: string;
  value?: string;
  onChange?: (value: any) => void;
}) {
  const [impactPreview, setImpactPreview] = useState<null | ImpactLocation>(
    null
  );
  return (
    <Flex vertical gap={16} style={{ width: '100%' }}>
      {/* Impact location input */}
      <Select
        mode="multiple"
        allowClear
        options={impactLocationOptions}
        {...selectMultipleProps}
        placeholder="Location of Impact"
        style={{ fontWeight: 'bold' }}
        placement="topRight"
        value={props.value}
        onChange={props.onChange}
        optionRender={option => {
          return (
            <Space
              onMouseEnter={() => {
                // Set the current option to be the previewed location
                setImpactPreview(option.value as ImpactLocation);
              }}
              onMouseLeave={() => {
                // Unset the current option
                setImpactPreview(null);
              }}
              style={{
                // Increase the hover area within the popup
                width: '100%'
              }}
            >
              {option.value}
            </Space>
          );
        }}
      />
      {/* Impact location diagram */}
      <ImpactLocationDiagram
        locations={[
          // Display the impact locations or nothing if the value doesn't exist
          ...((props.value as any) ?? []),

          // Add impactPreview if it is not falsy (expected to be null)
          ...(impactPreview ? [impactPreview] : [])
        ]}
      />
    </Flex>
  );
}
